export const flowTaskZH = {
  flowTask1: '阶段进度',
  flowTask2: '后可查看任务详情哦',
  flowTask3: '知道了',
  flowTask4: '完成',
  flowTask5: '任务后，才可查看此任务哦~',
  flowTask6: '完成其中任意一个任务后，才可查看此任务哦~',
  flowTask7: '任务卡设置',
  flowTask8: '请设置任务卡显示规则：',
  flowTask9: '完成状态',
  flowTask10: '全部',
  flowTask11: '未完成',
  flowTask12: '已完成',
  flowTask13: '是否必选',
  flowTask14: '必选',
  flowTask15: '非必选',
  flowTask16: '是否限时',
  flowTask17: '限时',
  flowTask18: '非限时',
  flowTask19: '此任务卡尚未开启哦~',
  flowTask20: '此任务卡已结束',
  flowTask21: '请用手机访问www.webloom.cn，查看',
  flowTask22: '任务。',
  flowTask23: '立即体验',
  flowTask24: '练习',
  flowTask25: '课程',
  flowTask26: '考试',
  flowTask27: '排行榜',
  flowTask28: '成绩',
  flowTask29: '作业',
  flowTask30: '证书',
  flowTask31: '将于',
  flowTask32: '开启',
  flowTask33: '截止日期：',
  flowTask34: '距离截止还有',
  flowTask35: '前完成',
  flowTask36: '已结束',
  flowTask37: '前完成（已结束）',
  flowTask38: '天',
  flowTask39: '活动任务',
  flowTask40: '左右滑动可以切换哦~',
  flowTask41: '团队主页',
  flowTask42: '完成进度：',
  flowTask43: '请用电脑访问www.webloom.cn，查看',
  flowTask44: '前去练习',
  flowTask45: '题',
  flowTask46: '反馈',
  flowTask47: '反馈时间：',
  flowTask48: '评委一',
  flowTask49: '评委二',
  flowTask50: '未通过',
  flowTask51: '通过',
  flowTask52: '提交成功',
  flowTask53: '(已结束)',
  flowTask54: '您有前置任务 ',
  flowTask55: ' 未完成',
  flowTask56: '任务',
  flowTask57: '任务尚未开启',
  flowTask58: '请耐心等待，任务开启后才可查看详情哦~',
  flowTask59: '任务已结束！',
  flowTask60: '此任务尚未开启哦~',
  flowTask61: '请在手机中打开此任务~',
  flowTask62: '倒计时',
  flowTask63: '截止',
  flowTask64: '暂无需要你完成的任务~',
  flowTask65: '该页面不存在',
  flowTask66: '你未报名该活动季，无权限访问该任务',
  flowTask67: '我已仔细阅读并同意上述协议。',
  flowTask68: '时长',
  flowTask69: '该小节处于锁定状态，请先完成其他小节~',
  flowTask70: '上一篇',
  flowTask71: '下一篇',
  flowTask72: '查看测评结果',
  flowTask73: '前往完成测评',
  flowTask74: '目录'
}

export const flowTaskEN = {
  flowTask1: 'Stage Progress',
  flowTask2: 'After that, you can view the task details',
  flowTask3: 'Go now',
  flowTask4: 'After completing the ',
  flowTask5: ' task, you can view this task~',
  flowTask6: 'After completing any of these tasks, you can view this task~',
  flowTask7: 'Task Card Settings',
  flowTask8: 'Please set the task card display rules',
  flowTask9: 'Completion Status',
  flowTask10: 'All',
  flowTask11: 'To be continued',
  flowTask12: 'Completed',
  flowTask13: 'Required or not',
  flowTask14: 'Required',
  flowTask15: 'Optional',
  flowTask16: 'Time-limited or not',
  flowTask17: 'Limited time',
  flowTask18: 'Non-time-limited',
  flowTask19: 'This task has not yet been opened~',
  flowTask20: 'This task has ended',
  flowTask21: 'Please use your mobile phone to access the www.webloom.cn to view xxx tasks.',
  flowTask22: 'task',
  flowTask23: 'Try it now',
  flowTask24: 'Practice',
  flowTask25: 'Course',
  flowTask26: 'Examination',
  flowTask27: 'Table of ranking',
  flowTask28: 'Grades',
  flowTask29: 'Homework',
  flowTask30: 'Certificate',
  flowTask31: 'Will be opened in ',
  flowTask32: '',
  flowTask33: 'Cut-off date:',
  flowTask34: 'day(s) to deadline',
  flowTask35: 'Pre-finish',
  flowTask36: 'Ended',
  flowTask37: 'Pre-Completed (Ended)',
  flowTask38: 'day(s)',
  flowTask39: 'Activity Tasks',
  flowTask40: 'Swipe left and right to switch oh ~',
  flowTask41: 'Team',
  flowTask42: 'Progress completed',
  flowTask43: 'Please visit www.webloom.cn from your computer to view ',
  flowTask44: 'Go to practice',
  flowTask45: 'Question',
  flowTask46: 'Feedback',
  flowTask47: 'Feedback time：',
  flowTask48: 'Judge',
  flowTask49: 'Judge',
  flowTask50: 'Failed',
  flowTask51: 'Pass',
  flowTask52: 'Submitted successfully',
  flowTask53: '(Ended)',
  flowTask54: 'You have unfinished pre-tasks',
  flowTask55: '',
  flowTask56: 'tasks.',
  flowTask57: 'This task is not yet open',
  flowTask58: 'Please be patient, you can check the details only after the task is opened~',
  flowTask59: 'The task is over!',
  flowTask60: 'This task is not yet open~',
  flowTask61: 'Please open it in your cell phone',
  flowTask62: 'Time Remaning',
  flowTask63: 'Close on',
  flowTask64: 'There are no tasks to complete',
  flowTask68: 'Duration',
  flowTask69: 'This section is in a locked state, please complete other sections first~',
  flowTask70: 'Previous',
  flowTask71: 'Next',
  flowTask72: 'View evaluation results',
  flowTask73: 'Go to complete the evaluation',
  flowTask74: 'Catalogue',
  flowTask65: 'This page does not exist',
  flowTask66: 'You have not signed up for this season and do not have permission to access this task',
  flowTask67: `I've carefully read and agreed on the agreements mentioned above.`
}



// WEBPACK FOOTER //
// ./src/i18n/langs/flow/task.js